<template>
  <div v-if="!isInitialized">
    <slot name="fallback">
      <div
        class="flex items-center justify-center h-screen flex-col max-w-sm space-y-4 mx-auto"
      >
        <div>Laster informasjon...</div>
        <UProgress />
      </div>
    </slot>
  </div>
  <div v-else><slot /></div>
</template>

<script lang="ts" setup>
import { useDomainAddOnCatalogStore } from "~/stores/catalog/domain-addon-catalog";
import { useVpsCatalogStore } from "~/stores/catalog/vps-catalog";
import { useVpsAddOnCatalogStore } from "~/stores/catalog/vps-addon-catalog";
import { useTldCatalogStore } from "../../stores/catalog/tld-catalog";
import { useMicrosoft365CatalogStore } from "../../stores/catalog/microsoft-365-catalog";

const props = defineProps({
  store: String as PropType<
    | "cart"
    | "domain-addon-catalog"
    | "vps-catalog"
    | "vps-addon-catalog"
    | "tld-catalog"
    | "microsoft-365-catalog"
  >,
});

const isInitialized = computed(() => {
  switch (props.store) {
    case "cart": {
      const store = useCartStore();
      return store.initialized && !store.error;
    }
    case "tld-catalog": {
      const store = useTldCatalogStore();
      return store.isReady;
    }
    case "domain-addon-catalog": {
      const store = useDomainAddOnCatalogStore();
      return store.isReady;
    }
    case "vps-catalog": {
      const store = useVpsCatalogStore();
      return store.isReady;
    }
    case "vps-addon-catalog": {
      const store = useVpsAddOnCatalogStore();
      return store.isReady;
    }
    case "microsoft-365-catalog": {
      const store = useMicrosoft365CatalogStore();
      return store.isReady;
    }
    default:
      return false;
  }
});
</script>

<style></style>
